import Vue from "vue";
import Router from "vue-router";
import routes from "./routers";
import store from "@/store";
import { LoadingBar } from "view-design";

import { getToken, canTurnTo, clearToken } from "@/libs/util";
import config from "@/config";
const { homeName, loginPageName } = config;

Vue.use(Router);

const router = new Router({
  routes
});

const turnTo = (to, access, next) => {
  if (canTurnTo(to.name, access, routes)) next();
  // 有权限，可访问
  else next({ replace: true, name: "error_401" }); // 无权限，重定向到401页面
};

// add loading bar (top) for changing url
LoadingBar.config({
  color: "#48dbfb",
  failedColor: "#f0ad4e",
  height: 5
});

// user token & user access check
router.beforeEach((to, from, next) => {
  LoadingBar.start();
  const token = getToken();

  if (!token && to.name !== loginPageName) {
    // 未登录且要跳转的页面不是登录页
    next({
      name: loginPageName // 跳转到登录页
    });
  } else if (!token && to.name === loginPageName) {
    // 未登陆且要跳转的页面是登录页
    next(); // 跳转
  } else if (token && to.name === loginPageName) {
    // 已登录且要跳转的页面是登录页, 并且是新进访问的
    if (from.path == "/" || !from.path) {
      next({
        name: homeName // 跳转到homeName页
      });
    } else {
      next();
    }
  } else {
    if (store.state.user.hasGetInfo) {
      turnTo(to, store.state.user.access, next);
    } else {
      store
        .dispatch("getUserInfo")
        .then(user => {
          // 拉取用户信息
          turnTo(to, user.access, next);
        })
        .catch(() => {
          clearToken();
          next({
            name: loginPageName
          });
        });
    }
  }
});

router.afterEach(route => {
  LoadingBar.finish();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js